import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

export const helpDemandDashboard: ISidebarHelp = {
	title: 'Dashboard de Demanda',
	firstParagraph: `Previsão de demanda é o processo em que as empresas estimam a demanda e/ou necessidade futura de produtos e/ou serviços.`,
	secondParagraph: `Neste dashboard é possível analisar a sua demanda para os próximos meses em quantidade de produtos (gráfico de quantidades), bem como uma estimativa de receita bruta (gráfico da receita). Use os filtros de Canal de Venda e Família para visualização mais detalhada.`,
	thirdParagraph: `Acesse o botão "Ver Plano Irrestrito" para analisar a saída do seu processo de demanda por família de produto.`,
	firstLink: URL_CT360,
	secondLink: URL_FALE_CONOSCO,
};
